export var And1FoulTipinPlayer = {
  name: "and1-foul-player",
  component: "MainPanel",
  layout: "main-panel large",
  mode: "visible",
  text: "foul.select-player",
  showOn: [{ state: "primary", value: "and1-foul-tipin-player", operator: "is" }],
  allowFlag: true,
  allowCancel: false,
  showDetails: { events: ["foul"] },
  children: [
    // Select Player
    {
      name: "block-player-select",
      component: "PlayerSelect",
      layout: "player-select",
      mode: "visible",
      showOn: [true],
      startEvent: false,
      startPlay: false,
      options: {
        currentEntity: true,
        showBench: false,
        showCoach: false,
        currentEntityEvent: "foul",
      },
      actionGroups: [
        {
          actions: [
            { action: "copyEvent", value: "foul", type: "to" },
            { action: "sendEvent", value: "edit", type: "main" },
          ],
          conditions: [],
        },
        {
          actions: [
            {
              action: "nextState",
              value: "free-throws",
              type: "secondary",
            },
            { action: "nextState", value: null, type: "primary" },
          ],
          conditions: [{ item: "fixture.isGrassroots", operator: "not" }],
        },
        {
          actions: [
            { action: "nextState", value: "free-throws-select-locked", type: "secondary" },
            { action: "nextState", value: null, type: "primary" },
          ],
          conditions: [{ item: "fixture.isGrassroots", operator: "is" }],
        },
      ],
    },
  ],
};
